import { LockIcon } from 'lucide-react';
import { Trans } from 'react-i18next';

import ExternalLink from '@/components/ui/external-link';

const LockedAnswersNotice = ({ i18nKey }: { i18nKey: string }) => {
  return (
    <p className="flex gap-2 text-sm text-muted-foreground">
      <LockIcon aria-hidden className="size-4 shrink-0 mt-0.5" />
      <span>
        <Trans
          i18nKey={i18nKey}
          components={[<ExternalLink key="contactSupport" className="underline hover:no-underline" href={import.meta.env.VITE_APP_SUPPORT_NEW_REQUEST_URL} />]}
        />
      </span>
    </p>
  );
};
LockedAnswersNotice.displayName = 'LockedAnswersNotice';

export default LockedAnswersNotice;
